export default function formatTimestampToResponseTime(minutes) {
  if (!minutes && minutes !== 0) return 'Not available';

  if (minutes < 60) {
    return `Within ${minutes} minute${minutes === 1 ? '' : 's'}`;
  }

  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `Within ${hours} hour${hours === 1 ? '' : 's'}`;
  }

  const days = Math.floor(hours / 24);
  return `Within ${days} day${days === 1 ? '' : 's'}`;
}
